import React from 'react';
import { GhostIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE } from '../data/product';
export function SiteHeader() {
  return <header className="fixed inset-x-0 top-0 z-40 border-b border-line/70 bg-night" data-id="element-207" data-mp="19uzyoob10jcy">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-5 sm:px-8" data-id="element-208" data-mp="1nllchylmi33z">
        <a href="#top" className="flex items-center gap-2.5" aria-label="Halloween PE Ready home" data-id="element-209" data-mp="1ip4m0xqybcnq">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-pumpkin text-ink" data-id="element-210" data-mp="uz0n33opk132">
            <GhostIcon className="h-5 w-5" aria-hidden="true" data-id="element-211" data-mp="qy8ac0gmne21" />
          </span>
          <span className="font-display text-[15px] font-extrabold tracking-tight text-cream sm:text-base" data-id="element-212" data-mp="14xgbgywcow8v">
            HALLOWEEN PE READY<sup className="text-[9px]" data-id="element-213" data-mp="zw0qf6u6apqh">™</sup>
          </span>
        </a>
        <a href={CHECKOUT_URL} className="hidden h-10 items-center whitespace-nowrap rounded-lg bg-pumpkin px-4 font-display text-sm font-extrabold uppercase tracking-wide text-ink transition-colors duration-150 ease-out hover:bg-pumpkin-light sm:inline-flex" data-id="element-214" data-mp="2gaitzzi0fvvo">
          Get It — {PRICE}
        </a>
      </div>
    </header>;
}